import { ProductionJobView } from "../production-job-view.model";
import { ItemStateModel } from "./item-state.model";

export class ProductionJobState extends ItemStateModel {
    productionJobs: ProductionJobView[];
    caseProductionJobCount: number;
}

